import { useQuery, UseQueryResult } from '@tanstack/react-query';
import { AxiosError } from 'axios';
import {
    ConditionDefinitionDto,
    ConditionDefinitionTriggerOption,
    getConditionDefinitionPlaceholders,
    getConditionDefinitions,
    getConditionDefinitionTriggerOptions,
} from '../endpoints/conditionDefinitions';
import { FOCUS_STALE_TIME_MS } from './staleTime';

export const useConditionDefinitionsQuery = (): UseQueryResult<
    ConditionDefinitionDto[],
    AxiosError
> =>
    useQuery({
        queryKey: ['condition-definitions'],
        staleTime: FOCUS_STALE_TIME_MS,
        queryFn: getConditionDefinitions,
    });

export const useConditionDefinitionPlaceholdersQuery = (): UseQueryResult<string[], AxiosError> =>
    useQuery({
        queryKey: ['condition-definition-placeholders'],
        staleTime: FOCUS_STALE_TIME_MS,
        queryFn: getConditionDefinitionPlaceholders,
    });

// The options come from backend code, so they only change with a deploy.
export const useConditionDefinitionTriggerOptionsQuery = (
    enabled: boolean,
): UseQueryResult<ConditionDefinitionTriggerOption[], AxiosError> =>
    useQuery({
        queryKey: ['condition-definition-trigger-options'],
        staleTime: Infinity,
        queryFn: getConditionDefinitionTriggerOptions,
        enabled,
    });
